import React from "react";
import { TagsInput } from "react-tag-input-component";

const ResourceTags = ({
  selectedTags,
  handleTags,
  handleRemoveTag,
  suggestedTags,
  addSugggestTag,
  register
}) => (
  <div className="mb-3">
    <label htmlFor="tags" className="form-label">
      Tags
    </label>
    <input
      className="form-control"
      hidden
      {...register("tags")}
    />
    <TagsInput
      value={selectedTags}
      onChange={handleTags}
      onRemoved={handleRemoveTag}
      name="input-tags"
      placeHolder="Enter tags"
    />
    {suggestedTags ? (
      <div className="mt-2 tags-lbox">
        {suggestedTags.map((tg, i) => (
          <span
            key={tg._id || i}
            className="badge bg-white border rounded me-2 text-dark fw-normal fs-6 my-1 py-2 px-3 suggested-tag"
            onClick={() => {
              addSugggestTag(tg._id);
            }}
          >
            {tg._id}
          </span>
        ))}
      </div>
    ) : null}
  </div>
);

export default ResourceTags;
